class WakeLock {
  wakeLock: Awaited<ReturnType<typeof navigator.wakeLock.request>> | AbortController | null = null;

  request = () => {
    if (this.wakeLock) return;

    if ('WakeLock' in window && 'request' in window.WakeLock) {
      const controller = new AbortController();
      const signal = controller.signal;

      const makeRequestWakeLock = () => {
        // @ts-expect-error we have a check above
        window.WakeLock.request('screen', { signal }).catch((e: Error) => {
          if (e.name === 'AbortError') {
            console.log('Wake Lock was aborted');
          } else {
            console.error(`${e.name}, ${e.message}`);
          }
        });
        console.log('Wake Lock is active');
        return controller;
      };

      const handleVisibilityChange = () => {
        if (this.wakeLock !== null && document.visibilityState === 'visible') {
          this.wakeLock = makeRequestWakeLock();
        }
      };

      document.addEventListener('visibilitychange', handleVisibilityChange, { signal });
      makeRequestWakeLock();
    } else if ('wakeLock' in navigator && 'request' in navigator.wakeLock) {
      const makeRequestWakeLock = async () => {
        try {
          this.wakeLock = await navigator.wakeLock.request('screen');
          this.wakeLock.addEventListener('release', (e) => {
            console.log(e);
            console.log('Wake Lock was released');
          });
          console.log('Wake Lock is active');
        } catch (e) {
          console.error(`${(e as Error).name}, ${(e as Error).message}`);
        }
      };

      const handleVisibilityChange = () => {
        if (this.wakeLock !== null && document.visibilityState === 'visible') {
          makeRequestWakeLock();
        }
      };

      document.addEventListener('visibilitychange', handleVisibilityChange);
      makeRequestWakeLock();
    } else {
      console.error('Wake Lock API not supported.');
    }
  };

  release = () => {
    if (this.wakeLock && 'release' in this.wakeLock) {
      this.wakeLock.release();
      this.wakeLock = null;
    } else if (this.wakeLock instanceof AbortController) {
      this.wakeLock.abort();
      this.wakeLock = null;
    }
  };
}

export default new WakeLock();
